import { useQuery } from '@apollo/client';
import React from 'react';
import { ORDERS_QUERY } from '../../api/public/cabinet/orders';
import { REQUESTS_QUERY } from '../../api/public/cabinet/requests';
import ErrorAlert from '../ErrorAlert/ErrorAlert';
import CabinetOrders from './components/CabinetOrders';
import CabinetRequests from './components/CabinetRequests';
import ItemSkeleton from './components/ItemSkeleton';
import styles from './CabinetMainInfo.module.scss';
import Download from '../../public/images/newSVG/downloadWhite.svg';
import Plus from '../../public/images/newSVG/plus.svg';
import { Button } from '../Button/Button';

export const CabinetMainInfo = () => {
  const { data: ordersData, error: ordersError, loading: ordersLoading } = useQuery(ORDERS_QUERY, {
    variables: {
      limit: 3,
      offset: 0,
    },
    fetchPolicy: 'no-cache',
  });

  const { data: requestsData, error: requestsError, loading: requestsLoading } = useQuery(REQUESTS_QUERY, {
    variables: {
      limit: 3,
      offset: 0,
    },
    fetchPolicy: 'no-cache',
  });

  return (
    <div>
      <div className={styles.listSection}>
        <h3>Заявки и спецификации</h3>
        <div className={styles.requestBtns}>
          <Button icon={<Download />} variant='filled' type='link' href='/upload-specification'>Загрузить спецификацию</Button>
          <Button icon={<Plus />} type='link' href='/cabinet/requests/new'>Оформить заявку</Button>
        </div>
        {requestsLoading ? <ItemSkeleton /> :
        requestsError ? <ErrorAlert error={requestsError} /> :
        requestsData!.requests.data.length > 0 ? (
          <CabinetRequests requests={requestsData!.requests.data} />
        ) : (
          <p className={styles.emptyListText}>У Вас нет активных заявок.{' '}</p>
        )}
      </div>
      <div className={styles.listSection}>
        <h3>Заказы</h3>
        {ordersLoading ? <ItemSkeleton /> :
        ordersError ? <ErrorAlert error={ordersError} /> :
        ordersData!.orders.data.length > 0 ? (
          <CabinetOrders orders={ordersData!.orders.data} />
        ) : (
          <p className={styles.emptyListText}>У Вас нет активных заказов.{' '}</p>
        )}
      </div>
    </div>
  );
};

export default CabinetMainInfo;
